<template>
  <div
    class="guests-list"
  >
    <span class="guests-list_title">Информация о гостях</span>

    <div class="guests-list_body">
      <v-expansion-panels
        v-model="panelIndex"
        focusable
        :ref="`panels`"
      >
        <v-expansion-panel
          v-for="guest, index in guestsList"
          :key="guest.id"
        >
          <v-expansion-panel-header
            color="#EAEAEA"
          >
            <div class="guests-list_section-header-inner">
              <span class="guest-list_item-title">{{index + 1}}. Гость{{guest.secondName && guest.firstName ? `: ${guest.secondName} ${guest.firstName.substring(0,1)}. ${(!guest.isNoThirdName && guest.thirdName) ? guest.thirdName.substring(0,1) + '.' : ''}` : ``}}</span>
              <a
                href="javascript:void(0)"
                class="guests-list_delete-item"
                v-if="index > 0"
                @click.stop="removeGuest(guest.id)"
              >
                <v-icon>$cross</v-icon>
              </a>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <guest-form
              :id="guest.id"
              :index="index"
            ></guest-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div class="guests-list_footer">
      <a
        class="ui-btn ui-btn--darkgreen ui-btn--prepend-icon guests-list_add-btn"
        :class="(this.guestsList.length >= this.availableCnt) ? 'ui-btn--disabled' : ''"
        href="javascript:void(0)"
        @click.prevent="addGuest"
      >
        <v-icon class="ui-btn_icon">$pluse</v-icon>

        <span class="ui-btn_text">
          Добавить гостя
        </span>
      </a>
    </div>

  </div>
</template>

<script>
import GuestForm from '@/components/GuestForm.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
export default {
  name: 'guests-list',

  components: {
    GuestForm,
  },

  data: () => ({
    panelIndex: 0,
    // availableCnt: null,
    // complitedGuests: [],
  }),

  computed: {
    ...mapState({
      selectedVariantId: state => state.selection.selectedVariantId,
      availableCnt: state => state.selection.avilableGuestsCnt,
    }),

    ...mapGetters({
      getSelectedVariantData: 'selection/geVariantById',
      getGuestIndex: 'guestsModule/getGuestIndex',
      getGuestsFields: 'guestsModule/getGuestsFields',
    }),

    selectedVariant() {
      return this.getSelectedVariantData(this.selectedVariantId)
    },

    guestsList() {
      return this.getGuestsFields([
        'id',
        'firstName',
        'secondName',
        'thirdName',
        'isNoThirdName',
        'guestType',
        'birthday',
        'gender',
        'phone',
        'isPersonalCompleted',
      ])
    },

    completedGuests() {
      return this.guestsList.reduce((acc, cur) => {
        if (cur.isPersonalCompleted) acc.push(cur.id)
        return acc
      }, [])
    }
  },

  methods: {
    ...mapActions({
      storeAddGuest: 'guestsModule/addGuest',
      storeRemoveGuest: 'guestsModule/removeGuest',
      // storeCalcGuestPrice: 'guestsModule/calcGuestPrice',
    }),

    addGuest() {
      if(this.guestsList.length < this.availableCnt) {
        this.storeAddGuest()
        this.panelIndex = this.guestsList.length - 1
      }
    },

    removeGuest(id) {
      this.storeRemoveGuest(id)

      let deletablePanelIndex = this.getGuestIndex(id)
      let activePanelIndex = this.panelIndex


      setTimeout(() => {
        if(deletablePanelIndex < activePanelIndex) {
          if(activePanelIndex > 0) {
            this.panelIndex = activePanelIndex - 1
          } else {
            this.panelIndex = 0
          }
        }
      })

    },
  },

  watch: {
    completedGuests(value) {
    //     console.log(oldValue)
    //     console.log(newValue)

    //     this.guestsList.forEach(guest => {
    //       let panel = this.$refs[`guest-${guest.id}`][0]
    //       console.log(panel)

    //       // красим панель в зеленый если заполнено
    //       // в серый если нет
    //       if(newValue.find(id => id === guest.id)) {
    //         panel.header.$el.style.backgroundColor = '#ECFAFB'
    //       } else {
    //         panel.header.$el.style.backgroundColor = '#EAEAEA'
    //       }

    //       // если текущая панель активна, то переходим к следующей
    //       if(panel.isActive) {
    //         this.panelIndex++
    //       }

    //     })
    },

    panelIndex(newVal, oldVal) {
      // console.log(`old value: ${oldVal}`)
      // console.log(`new value: ${newVal}`)
    }
  },

  beforeMount() {
    if(this.guestsList.length === 0) {
      // for(let i = 0; i < this.storeGuestsCnt; i++) {
      this.storeAddGuest()
      // }
    }
  },
}
</script>

<style lang="sass">
.guests-list_title
  display: block
  margin-bottom: px-em(25, 18)
  font-size: 1.125em
  font-weight: 700
  color: #696D74

.guests-list_footer
  width: 100%
  display: flex
  margin-top: px-em(30)

.guests-list_section-header-inner
  width: 100%
  display: flex
  align-items: center

.v-application .guests-list_delete-item,
.guests-list_delete-item
  display: inline-block
  margin-left: auto
  font-size: px-em(8)
  color: #C01717
  padding: px-em(4, 8) px-em(5, 8) px-em(6, 8)
  // position: absolute
  // top: 50%
  // right: 0
  // transform: translateY(-50%)
  // margin-right: -40px

  .v-icon.v-icon
    font-size: inherit

  .theme--light.v-icon
    color: inherit

  .v-icon__component
    width: 1em
    height: auto

@media screen and (max-width: $mobile-breakpoint)
  .guests-list_add-btn
    width: 100%

  .v-application .guests-list_delete-item,
  .guests-list_delete-item
    font-size: px-em(10, 12)
</style>
